import React  from 'react';
import './App.css';
import { useState } from 'react';
import Home from './pages/Home';

function App() {
  const [url, setUrl] = useState('/');

  function gettingComponent(){
    if(url === '/'){
      return <Home/>
    }
  }
  return gettingComponent();
}

export default App;
